var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconPushNotification = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#525254",
  fillRule: "evenodd",
  d: "M12.1 1.999A5 5 0 0 0 12.1 4H4.7a.7.7 0 0 0-.7.7v10.6a.7.7 0 0 0 .7.7h10.6a.7.7 0 0 0 .7-.7V7.9a5 5 0 0 0 2 0v7.4a2.7 2.7 0 0 1-2.7 2.7H4.7A2.7 2.7 0 0 1 2 15.3V4.7A2.7 2.7 0 0 1 4.7 2zM17 .5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5"
})));
export default SvgIconPushNotification;